import { SelectionModel } from '@angular/cdk/collections';

import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { IAttachedAsset } from '@app/domain/cmms-types/workorder-types';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
	selector: 'assets-tab',
	imports: [
		MatCardModule,
		MatCheckboxModule,
		MatIconModule,
		MatMenuModule,
		MatButtonModule,
		NgxTolgeeModule,
	],
	templateUrl: './assets-tab.component.html',
	styleUrls: [
		'./assets-tab.component.scss',
		'../../../../shared/styles/entity-tabs.scss',
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssetsTabComponent {
	assets = input<IAttachedAsset[]>();
	workorderPk = input<string>();

	updateData = output<{
		assets: { id: string; name: string }[];
	}>();

	assetSelections = new SelectionModel<IAttachedAsset>(
		true,
		[],
		true,
		(a, b) => a.pk === b.pk
	);

	unlinkAssets() {
		const filteredAssets = this.assets().filter(
			asset => !this.assetSelections.isSelected(asset)
		);
		this.updateData.emit({
			assets: filteredAssets.map(asset => ({
				id: asset.pk,
				name: asset.name,
			})),
		});
	}
}
